<script>
    import {slide} from 'svelte/transition';
    import emotion from 'emotion/dist/emotion.umd.min.js';
    import {sgettext} from '../../i18n.js';

    export let title = '';
    export let showTitleExclamationCircle = false;
    export let showEllipsis;
    export let cssClasses = '';
    export let draggable = false;
    export let collapsible = true;
    export let padded = false;
    export let headerColour = '#6c757d';
    export let headerTextColour = 'white';
    export let stickyHeader = false;
    export let style = '';
    export let hideOverflowX = false;
    export let hideOverflowY = false;
    export let key = '';
    export let item = null;
    export let entity = '';
    export let onDrop = () => {
    };
    export let onDragOver = () => {
    };
    export let onDragStart = () => {
    };
    export let onDragEnd = () => {
    };
    export let onDragLeave = () => {
    };
    export let onHeaderMouseDown = () => {
    };
    export let onHeaderContextMenu = () => {
    };
    export let rightPanelWidth;
    export let elementIdText;

    const {css} = emotion;
    let showOverlay = false;

    
    const headerStyle = css`
        background-color: ${headerColour};
        padding: 5px 0 5px 10px;
        color: ${headerTextColour};
        display: flex;
        height: 34px;
    `;

    const stickyStyle = css`
        ${stickyHeader ? 'position: sticky; top: 0;' : ''}
    `;

    let showContent = true;
    let allowDrop = false;

    function dragStart(event) {
        event.stopPropagation();
        onDragStart(event, item);
    }

    function onDrag(event) {
    }

    function handleDrop(event){
        showOverlay = false;
        onDrop(event);
    }

    function handleDragOver(event) {
        allowDrop = onDragOver(event);
        if (allowDrop) {
            showOverlay = true;
        } else {
            showOverlay = false;
        }
    }

    function handleDragEnd(event) {
        showOverlay = false;
        onDragEnd(event);
    }

    function handleDragLeave(event) {
        showOverlay = false;
        onDragLeave(event);
    }

    function toggleCollapsible() {
        showContent = !showContent;
    }

    function onContextMenu(event) {
        onHeaderContextMenu(event, item);
    }

    function onMouseDown(event) {
        onHeaderMouseDown(event, item, entity);
    }

    function onShowMenu(event) {
        event.stopPropagation();
        const menuPosition = {
            x: event.clientX,
            y: event.clientY
        };

        dispatch('showMenu', {
            menuPosition, context: {
                item,
                entity
            }
        });
    }

    const titleColumnCss = css`
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    `;

</script>

<style>
    .panel {
        flex: 1;
        height: 100%;
        position: relative;
    }

    .whiteBackground {
        background-color: white;
    }

    .fas {
        cursor: pointer;
        margin-right: 10px;
    }

    .fas:hover {
        color: #ffd691;
    }

    .padded {
        padding: 10px 0;
    }

    .title {
        flex: 1;
    }


    /*.panel, .body, :global(div[slot="body"]) {*/
    /*    display: flex;*/
    /*    flex-direction: column;*/
    /*    height: 100%;*/
    /*}*/

    .body {
        height: calc(100% - 30px);
        overflow: auto;
    }

    .hideOverflowX {
        overflow-x: hidden;
    }

    .hideOverflowY {
        overflow-y: hidden;
    }

    .panel.cut, .panel.copied {
        border: 1px dashed #454545;
    }

    .panel.cut {
        opacity: 0.5;
    }

    .panel.after {
        border-bottom: 3px solid #454545;
    }

    .panel.before {
        border-top: 3px solid #454545;
    }

    .panel.selected header {
        background-color: #fab636;
    }

    .panel.selected {
        outline: 1px solid #fab636;
    }

    .overlay {
        background-color: rgba(165, 220, 110, 0.2);
        position: absolute;
        width: 100%;
        height: 100%;
        pointer-events: none;
    }
</style>

<div
        class="{`panel ${cssClasses}`}"
        class:allow-drop={allowDrop}
        {key}
        on:dragover|preventDefault|stopPropagation={handleDragOver}
        on:dragleave={handleDragLeave}
        on:dragend={handleDragEnd}
        on:drop|preventDefault={handleDrop}>
    {#if showOverlay}
        <div class="overlay"></div>
    {/if}
    <slot name="header">
        <div class={stickyStyle}>
            <header
                    class={headerStyle}
                    {draggable}
                    on:contextmenu|preventDefault={onContextMenu}
                    on:mousedown|stopPropagation={onMouseDown}
                    on:dragstart={dragStart}
                    on:drag={onDrag}>
                {#if collapsible}
                    <span>
                        <i
                                on:click={toggleCollapsible}
                                class:motion-icon--expand={showContent}
                                class:motion-icon--collapse={!showContent}
                                class="fas fa5-caret-square-right"
                                aria-hidden="true"/>
                    </span>
                {/if}

                {#if showEllipsis && title}
                    <span class={titleColumnCss} style="max-width:{rightPanelWidth - 200}px;">
                        {#if showTitleExclamationCircle}
                        <i class="fa fa-exclamation-circle text-white mr-2 mt-1"></i>
                        {/if}
                        <strong>{title}</strong>
                    </span>
                    <span style="width:200px;padding-left:5px;">
                        <strong>{elementIdText ? elementIdText : ''}</strong>
                    </span>
                {:else if title}
                    <span class="title"><strong>{title}</strong></span><span style="padding-left:5px;"><strong>{elementIdText ? elementIdText: ''}</strong></span>
                {:else}
                    <slot name="title">{sgettext('$$TITLE$$')}</slot>
                {/if}
                <slot name="additionalInfo"/>
                <slot name="menuToggle">
                    <div style="width: 10px"></div>
                </slot>
            </header>
            <slot name="headerExtra" />
        </div>
    </slot>

    {#if showContent}
        <div
                class="body"
                class:padded
                class:hideOverflowX
                class:hideOverflowY
                class:whiteBackground={!padded}
                style="{style}"
                transition:slide|local="{{duration: 500 }}">
            <slot name="body"/>
        </div>
    {/if}
</div>
